<div class="m-t-10"></div>
<form class="m-t-20" #myform="ngForm" (ngSubmit)="onSubmit(myform)">
    <div class="container-fluid">
        <div class="row">
            <div *ngIf="vehicleBrandIsNotOV" class="col-sm-6">
                <mat-button-toggle-group name="fontStyle" aria-label="Font Style" #group="matButtonToggleGroup"
                    value="{{serviceusage}}" class="maintenance-switch" [value]="serviceusage">
                    <mat-button-toggle [disabled]="true" value="NORMAL" class="maintenance-switch-text"><span
                            translate>dimbo.i18n.button.Normal</span></mat-button-toggle>
                    <mat-button-toggle [disabled]="true" value="SEVERE" class="maintenance-switch-text"><span
                            translate>dimbo.i18n.button.Severe</span></mat-button-toggle>
                </mat-button-toggle-group>
            </div>
        </div>
    </div>

    <div *ngIf="typesOfServices.length > 0">
        <div class="container-fluid">
            <div class="row m-b-15 m-t-20">
                <div class="col-sm-4 service-header-text"><span class="p-l-50"
                        translate>dimbo.i18n.header.TypeofService</span></div>
                <div class="col-sm-4 service-header-text"><span class="p-l-25"
                        translate>dimbo.i18n.header.Frequency</span></div>
            </div>
        </div>

        <div class="container-fluid default-bg-color">

            <mat-selection-list #services>
                <mat-list-option checkboxPosition="before" *ngFor="let service of typesOfServices"
                    (click)="onServiceListControlChanged(services)" [value]="service.id" class="service-list">
                    <div class="row">
                        <div class="col-sm-4 maintenance-service-name-text">{{service.serviceName}}</div>
                        <div class="col-sm-4 service-frequency-text">{{service.stepFrequency}}</div>
                    </div>
                </mat-list-option>
            </mat-selection-list>
        </div>
    </div>
    <!-- Current Service Section -->
    <div class="row">
        <div class="default-bg-color m-t-20">
            <div *ngIf="selectedOption.length > 0">
                <div class="container-fluid">
                    <div class="float-left print-button print-button-text" (click)="addServices()" translate>
                        dimbo.i18n.button.Add</div>
                </div>
            </div>
            <div *ngIf="selectedOption.length < 1">
                <div class="container-fluid">
                    <div class="float-left print-button print-button-text" style="opacity: 0.3;" translate>
                        dimbo.i18n.button.Add</div>
                </div>
            </div>
        </div>

        <div class="container-fluid m-t-25 ">
            <div class="row">
                <div class=" col-4 current-service-header-text m-t-25" translate>dimbo.i18n.header.CurrentService</div>
                <div class=" font-weight-light m-t-25"><span translate>dimbo.i18n.label.serviceDate</span>
                    {{servicedate|date}}</div>
                <div class=" m-t-25 m-l-20">|</div>
                <div class=" font-weight-light m-t-25 m-l-20"><span translate>dimbo.i18n.label.serviceMileage</span>
                    {{mileagevalue}} {{mileageunit}}</div>
                <div class="m-t-25 m-l-20">
                    <span class="float-left event-hover" (click)="onmileageEdit()" style="color:#1F54A3 ">
                        <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
                    </span>
                </div>
            </div>
        </div>
        <div class="container-fluid bg-color-white m-t-20 m-b-25"
            style="box-shadow: 4px 4px 6px 4px rgb(245, 241, 241); min-height: 300px;">
            <div class="row justify-content-start">

                <!-- Maintaenance Operation section -->
                <div class="col-sm-6 m-b-20">
                    <p class="m-t-20 maintenance-operation-text" translate>dimbo.i18n.header.MaintenanceOperation</p>
                    <div class="row">
                        <div class="col-sm-11">
                            <mat-selection-list [multiple]="false">
                                <mat-list-option *ngFor="let operation of singleserviceoperation"
                                    [value]="operation.maintenancePlanReference" class="service-list">
                                    <div class="row">
                                        <div class="col-sm-8 maintenance-service-name-text">{{operation.label}}</div>
                                        <div class="col-sm-2">
                                            <span class="material-icons float-right"
                                                (click)="onServiceOperationChanged(operation)">
                                                delete_outline
                                            </span>
                                        </div>
                                    </div>
                                </mat-list-option>
                            </mat-selection-list>
                        </div>

                    </div>

                    <div class="row">
                        <div class="col-sm-11">
                            <mat-form-field style="width: 100%;">
                                <mat-label translate>dimbo.i18n.label.Comment</mat-label>
                                <textarea name="servicehistorycomment" matInput [(ngModel)]="servicehistorycomment"
                                    [value]="servicehistorycomment" maxlength="4000"
                                    (change)="changeservicehistorycomment($event)"></textarea>
                            </mat-form-field>
                        </div>

                    </div>



                </div>

                <div class="m-t-20 vertical-line"></div>

                <!-- Antiperforation section -->
                <div class="col-sm-5 ">
                    <div class="row m-t-20">
                        <div class="col-sm-8">
                            <span class="p-l-30 m-t-20 maintenance-operation-text"
                                translate>dimbo.i18n.header.AntiPerforationCheck</span>
                            <span class="m-l-20">
                                <mat-slide-toggle [(ngModel)]="antiperforationCheck" name="antiperforationCheck"
                                    [checked]="antiperforationCheck === true ? true : false"
                                    (change)="setAntiperforation( $event )"></mat-slide-toggle>
                            </span>
                        </div>
                    </div>
                    <div class="container" *ngIf="antiperforationCheck">
                        <div class="row">
                            <div class="col-sm-6 m-t-30 m-l-30 anti-perforation-text" translate>
                                dimbo.i18n.label.AntiPerforationInspection</div>
                            <div class="col-sm-5 float-left">
                                <mat-form-field>
                                    <mat-select [(ngModel)]="selecctedantiperforationperiod"
                                        name="antiperforationperiod" [value]="selecctedantiperforationperiod"
                                        (selectionChange)="onChangeAntiperforationperiod($event.value)">
                                        <mat-option *ngFor="let year of numberOfYears" [value]="year">
                                            {{year}} <span translate>dimbo.i18n.label.Year</span>
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <span class="m-l-30 p-l-15 anti-perforation-text"
                                translate>dimbo.i18n.label.AntiPerforationIssueDetected</span>
                            <span class="m-l-20">
                                <mat-slide-toggle (change)="changeissueDetected($event)" [(ngModel)]="issueDetected"
                                    [checked]="issueDetected === true ? true : false" name="issueDetected">
                                </mat-slide-toggle>
                            </span>
                        </div>
                        <div class="row" *ngIf="issueDetected">
                            <mat-form-field class="m-l-30 p-l-15" style="width: 100%;">
                                <mat-label translate>dimbo.i18n.label.Comment</mat-label>
                                <textarea matInput [(ngModel)]="antiperforationcomment" name="antiperforationcomment"
                                    maxlength="4000" [value]="antiperforationcomment"
                                    (change)="changeantiperforationcomment($event)"></textarea>
                            </mat-form-field>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
    <input class="float-right print-button print-button-text m-r-10 m-t-10" style="padding-top: 7px;" type="submit"
        [value]="submittranlation">
    <input class="float-right cancel-button cancel-button-text m-r-10 m-t-10" type="button" [value]="canceltranlation"
        (click)="closedit()">
</form>